<div class="usage-exceeded-container">
    <div class="modal custom-container">
        <div class="header cta">
            <div class="smash-logo purple">
                <i class="icon-smash_icologo_chip"></i>
            </div>
            <h1 translate>MODAL_USAGE_EXCEEDED_TITLE</h1>
        </div>
        <div class="body cta">
            <div class="section">
                <div class="description">
                    {{ 'MODAL_USAGE_EXCEEDED_DESCRIPTION' | translate }}
                </div>
            </div>
            <div class="section">
                <div>
                    <button class="btn-rounded dark" (click)="retry()">{{ 'MODAL_USAGE_EXCEEDED_BUTTON_LABEL_ACTION_RETRY' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
